// extracted by mini-css-extract-plugin
export var searchHeader = "_8x-0";
export var searchHeaderDark = "_8x-1";